import React, { useState, useEffect } from 'react';
import teamService from '../services/teamService';
import './TeamSelector.css';

const TeamSelector = ({ onTeamSelect, onClose }) => {
  const [teams, setTeams] = useState([]);
  const [newTeamName, setNewTeamName] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadTeams();
  }, []);

  const loadTeams = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const isHealthy = await teamService.checkApiHealth();
      if (!isHealthy) {
        setTeams([]);
        setError('API сервер недоступен. Невозможно загрузить список команд.');
        return;
      }

      const teamsList = await teamService.getAllTeams();
      setTeams(teamsList);
    } catch (loadError) {
      console.error('Ошибка загрузки команд:', loadError);
      setTeams([]);
      setError('Не удалось загрузить команды. Проверьте подключение к серверу.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddTeam = async () => {
    if (!newTeamName.trim() || teams.includes(newTeamName.trim())) {
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      await teamService.createTeam(newTeamName.trim());
      const updatedTeams = [...teams, newTeamName.trim()];
      setTeams(updatedTeams);
      setNewTeamName('');
      setSelectedTeam(newTeamName.trim());
      setShowDropdown(false);
      onTeamSelect(newTeamName.trim());
    } catch (createError) {
      console.error('Ошибка создания команды:', createError);
      setError('Не удалось создать команду. Проверьте подключение к серверу.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectTeam = async (teamName) => {
    try {
      setIsLoading(true);
      setError(null);
      setSelectedTeam(teamName);
      setShowDropdown(false);
      onTeamSelect(teamName);
    } catch (selectError) {
      console.error('Ошибка при выборе команды:', selectError);
      setError('Ошибка при выборе команды. Попробуйте еще раз.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAddTeam();
    }
  };

  return (
    <div className="team-selector-overlay">
      <div className="team-selector-modal">
        <button className="team-selector-close" onClick={onClose} title="Закрыть окно" type="button">
          ✕
        </button>
        <div className="team-selector-header">
          <h2>Выберите команду</h2>
          <p>Введите название новой команды или выберите существующую</p>
        </div>

        {error && <div className="team-selector-error">{error}</div>}

        <div className="team-selector-content">
          <div className="new-team-section">
            <label htmlFor="newTeamInput">Название новой команды:</label>
            <div className="input-group">
              <input
                id="newTeamInput"
                type="text"
                value={newTeamName}
                onChange={(event) => setNewTeamName(event.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Введите название команды..."
                className="team-input"
              />
              <button
                onClick={handleAddTeam}
                disabled={!newTeamName.trim() || teams.includes(newTeamName.trim()) || isLoading}
                className="add-team-btn"
                type="button"
              >
                {isLoading ? 'Добавление...' : 'Добавить'}
              </button>
            </div>
          </div>

          <div className="existing-teams-section">
            <label>Существующие команды:</label>
            <div className="teams-dropdown">
              <button
                className="teams-dropdown-toggle"
                onClick={() => setShowDropdown(!showDropdown)}
                disabled={isLoading}
                type="button"
              >
                {selectedTeam || 'Выберите команду...'}
                <span className="dropdown-arrow">▼</span>
              </button>

              {showDropdown && (
                <div className="teams-dropdown-menu">
                  {teams.length > 0 ? (
                    teams.map((team) => (
                      <button
                        key={team}
                        type="button"
                        className={`team-option ${selectedTeam === team ? 'selected' : ''}`}
                        onClick={() => handleSelectTeam(team)}
                        disabled={isLoading}
                      >
                        {team}
                      </button>
                    ))
                  ) : (
                    <div className="no-teams-message">Нет доступных команд</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamSelector;
